import { Link, useHistory } from 'react-router-dom';
import { BordOneToneIcon } from 'components/NudosComponents';

import './BreadCrumbs.scss';

export interface IBreadcrumbItem {
  label: string;
  href: string;
  goBack?: boolean;
}

interface IBreadcrumbsProps {
  items: IBreadcrumbItem[];
}

export const Breadcrumbs = ({ items }: IBreadcrumbsProps) => {
  const history = useHistory();
  return (
    <nav className="breadcrumbs">
      <ol className="breadcrumbsList">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (item.goBack) {
            return (
              <li key={item.href} className="breadcrumbsItem">
                <button className="breadcrumbsLink" onClick={() => history.push(item.href)}>
                  <BordOneToneIcon variant="arrowHeadLeft" className="breadcrumbsGoBackIcon" customWidth="20px" />
                  {item.label}
                </button>
              </li>
            );
          }
          return (
            <li key={item.href} className="breadcrumbsItem">
              {index > 0 && <span className="separator">/</span>}
              {isLast ? (
                <span className="breadcrumbsText ">{item.label}</span>
              ) : (
                <Link to={item.href} className="breadcrumbsLink">
                  {index === 0 && (
                    <BordOneToneIcon variant="arrowHeadLeft" className="breadcrumbsGoBackIcon" customWidth="20px" />
                  )}
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
